import { AxiosResponse } from 'axios';

import { IVisit } from '../../shared/ts/visit';
import httpRequest from '../httpRequest';

const baseUrl = process.env.REACT_APP_GW_API_URL;
const portalVersion = process.env.REACT_APP_PORTAL_VISIT_SELECTION_API_VERSION;

const confirmVisitAPI = {
  getConfirmVisit: async (visitId: string): Promise<IVisit> => {
    const { data } = (await httpRequest({
      url: `${baseUrl}/${portalVersion}/portal/visits/${visitId}/selection`,
      method: 'GET',
    })) as AxiosResponse;
    return data;
  },
  confirmVisit: async (visitId: string): Promise<void> => {
    await httpRequest({
      url: `${baseUrl}/${portalVersion}/portal/visits/${visitId}/verify`,
      method: 'PATCH',
    });
  },
  cancelVisit: async (visitId: string): Promise<void> => {
    await httpRequest({
      url: `${baseUrl}/${portalVersion}/portal/visits/${visitId}`,
      method: 'DELETE',
    });
  },
};

export default confirmVisitAPI;
